import { Link } from "react-router-dom";

const TABS = [
    { key: "transfer", label: "Transfer Control Envelope", to: "/request/TX-BOND-001" },
    { key: "ca", label: "Corporate Action Election Envelope", to: "/request/CA-ELEC-001" },
];

export const ScenarioTabs = ({ active }) => (
    <div className="mb-6" data-testid="scenario-tabs">
        <p className="max-w-3xl text-xs leading-relaxed text-slate-500" data-testid="scenario-tabs-intro">
            The same Control Decision Envelope pattern is shown in two settings: a
            simple transfer and a corporate-action election. The first proves
            movement control. The second proves lifecycle control with parent
            event, option and election dependency.
        </p>
        <div className="mt-3 inline-flex overflow-hidden rounded-sm border border-slate-200 bg-slate-200 gap-px">
            {TABS.map((t) => (
                <Link
                    key={t.key}
                    to={t.to}
                    data-testid={`scenario-tab-${t.key}`}
                    className={`px-4 py-2 text-sm transition-colors duration-150 ${
                        active === t.key
                            ? "bg-blue-950 font-medium text-white"
                            : "bg-white text-slate-600 hover:bg-slate-50"
                    }`}
                >
                    {t.label}
                </Link>
            ))}
        </div>
    </div>
);
